import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';

export const loginGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (route.queryParamMap.get('logout') === '1') {
    return true;
  }

  const isAuthenticated = await authService.ensureSession();
  if (!isAuthenticated) {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl');
  const target = returnUrl?.startsWith('/') ? returnUrl : '/dashboard';
  return router.createUrlTree([target]);
};
